import React from 'react';
import { Form, Icon, Input, Row, Tooltip, Checkbox, Alert } from 'antd';
import { emergencyGlobalChannelId, emergencyAlarmChannelId } from '../../../core/constants';

function PushConfiguration({ selectedChannels, me, content, form }) {
  const { getFieldDecorator } = form;

  // If no channels are selected, show a hint to select channels first
  if (!selectedChannels || Object.keys(selectedChannels).length === 0) {
    return (
      <Form.Item className="align-left verify-section">
        <div>
          <div className="color-secondary weight-medium verify-section-headline">Push Konfiguration</div>
          <Alert
            message="Um eine Push-Benachrichtigung zu versenden, wähle bitte zuerst mindestens einen Channel oben aus!"
            type="info"
            showIcon
          />
        </div>
      </Form.Item>
    );
  }

  // Check if emergency alarm channel is selected
  const isEmergencyAlarmSelected =
    selectedChannels &&
    Object.values(selectedChannels).some((item) => item?.channel?.globalChannel === emergencyAlarmChannelId);

  // If emergency alarm is selected, show alert instead of configuration
  if (isEmergencyAlarmSelected) {
    return (
      <Form.Item className="align-left verify-section">
        <div>
          <div className="color-secondary weight-medium verify-section-headline">Push Konfiguration</div>
          <Alert
            message="Bei einem Notfall mit Alarm können keine Push-Einstellungen konfiguriert werden. Die Push-Benachrichtigung wird automatisch versendet."
            type="info"
            showIcon
          />
          {/* Hidden field to ensure sendPush is true for emergency alarms */}
          {getFieldDecorator('sendPush', {
            valuePropName: 'checked',
            initialValue: true,
          })(<input type="hidden" />)}
        </div>
      </Form.Item>
    );
  }

  return (
    <Form.Item className="align-left verify-section">
      <div>
        <div className="color-secondary weight-medium verify-section-headline">
          Push Konfiguration (optional) &nbsp;
          <Tooltip
            placement="right"
            title="Lege benutzerdefinierte Texte fest, die dem Nutzer in der Push Mitteilung angezeigt werden."
          >
            <Icon type="question-circle-o" />
          </Tooltip>
        </div>
        <Row>
          <Form.Item className="padded-input">
            {getFieldDecorator('sendPush', {
              valuePropName: 'checked',
              initialValue: true,
            })(<Checkbox>Push-Benachrichtigung senden</Checkbox>)}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item className="padded-input">
            {getFieldDecorator('pushconfig.title', {
              initialValue: undefined,
            })(
              <Input
                placeholder={
                  Object.keys(selectedChannels).find((el) => el === emergencyAlarmChannelId)
                    ? 'Notfall mit Alarm'
                    : Object.keys(selectedChannels).find((el) => el === emergencyGlobalChannelId)
                    ? 'Notfall'
                    : 'Neuer Post'
                }
              />
            )}
          </Form.Item>
          <Form.Item className="padded-input">
            {getFieldDecorator('pushconfig.text', {
              initialValue: undefined,
            })(
              <Input.TextArea
                autoSize={{ minRows: 2, maxRows: 2 }}
                placeholder={
                  Object.keys(selectedChannels).find((el) => el === emergencyAlarmChannelId)
                    ? content
                    : Object.keys(selectedChannels).find((el) => el === emergencyGlobalChannelId)
                    ? content
                    : `${me.username} hat einen neuen Beitrag erstellt.`
                }
              />
            )}
          </Form.Item>
        </Row>
      </div>
    </Form.Item>
  );
}

export default PushConfiguration;
